export default __webpack_public_path__ + "static/media/cert-general-staff-a-HKIRC.4f62ab44.jpg";